export default __webpack_public_path__ + "static/media/pipedGas.aa821945.svg";